var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-button",class:{
    'nav-button--dashboard': _vm.type === 'dashboard',
    'nav-button--with-icon': _vm.icon,
    'nav-button--disabled': _vm.disabled,
  },style:(_vm.bgi),attrs:{"to":_vm.link,"disabled":_vm.disabled}},[_c('span',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }